import {studentSchoolName} from '../../utils/studentSchool.js';
import {getStudentGradeLabel} from '../../utils/academy.js';
// Display only. Keep stored school names, IDs and filters intact.
export function studentListSchoolName(value,academyInfo){
 return studentSchoolName(value,academyInfo).replace(/^서울\s*/, '').replace(/여자고등학교$/, '여고').replace(/초등학교$/, '초').replace(/중학교$/, '중').replace(/고등학교$/, '고');
}
export function studentListGrade(student){
 const prefix={초등:'초',중등:'중',고등:'고'}[student?.schoolLevel];
 return prefix&&student.grade?`${prefix}${student.grade}`:getStudentGradeLabel(student);
}
